import React from "react";
import { Row, Col, Jumbotron, Form, Button, Image } from "react-bootstrap";
export default function Step3() {
  const { facebook, loading, biz_channel } = this.state;

  var InputForm = <div className="mx-auto"><p>Please select a channel.</p></div>  
  if (biz_channel == "facebook"){
    InputForm =  <div className="facebook_channel">
    <h4 className="text-muted font-weight-light">
      Step 3: Channel Integration
    </h4>

    <Form className="pt-3">
      <Form.Group>
        <div className="input-group">
          <Form.Control
            type="text"
            className="form-control"
            placeholder="Facebook Page ID"
            name="page_id"
            value={facebook.page_id}
            onChange={this.handleFacebook}
          />
          <div className="input-group-append">
            <button className="btn btn-sm btn-facebook" type="button">
              <i className="mdi mdi-facebook"></i>
            </button>
          </div>
        </div>
      </Form.Group>
      <Form.Group>
        <Form.Row>
          <Col>
            <Form.Control
              name="app_id"
              placeholder="App ID"
              value={facebook.app_id}
              onChange={this.handleFacebook}
            />
          </Col>
          <Col>
            <Form.Control
              name="app_secret_key"
              placeholder="App Key"
              type="password"
              value={facebook.app_secret_key}
              onChange={this.handleFacebook}
            />
          </Col>
        </Form.Row>
      </Form.Group>

      <Form.Group>
        <label>Logo Image</label>
        <div className="custom-file">
          <Form.Control
            type="file"
            name="image"
            onChange={this.handleFacebook}
            className="form-control visibility-hidden"
            id="customFileLang"
            lang="es"
          />
          <label className="custom-file-label" htmlFor="customFileLang">
            Upload image
          </label>
        </div>
      </Form.Group>

      {/* <Form.Group>
        <Form.File
          className="position-relative"
          required
          name="image"
          label="File"
          onChange={this.handleFacebook}
          // value={facebook.image}
          //   isInvalid={!!errors.file}
          //   feedback={errors.file}
          //   id="validationFormik107"
          //   feedbackTooltip
        />
      </Form.Group> */}
      {/* 
      <Image src={facebook.image} fluid /> */}
      {facebook.image ? (
        <div className="text-center pb-3">
          <img
            src={facebook.image}
            className="img-thumbnail brand-logo-preview"
          />
        </div>
      ) : (
        ""
      )}
    </Form>

    <Button
      size="sm"
      variant="primary"
      type="submit"
      onClick={this.handleSubmit}
      block
    >
      {loading ? (
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        >
          {"  "}
        </span>
      ) : (
        "Submit"
      )}
    </Button>
  </div>

  }
  return (
    <>
   {InputForm}  
   </>
  );
}
